var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 4.66667H2.50033C2.0281 4.66667 1.66699 4.30555 1.66699 3.83333C1.66699 3.36111 2.0281 3 2.50033 3H17.5003C17.9725 3 18.3337 3.36111 18.3337 3.83333C18.3337 4.30555 17.9725 4.66667 17.5003 4.66667Z",
    fill: "#FFF8EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 9.111H2.50033C2.0281 9.111 1.66699 8.74989 1.66699 8.27767C1.66699 7.80545 2.0281 7.44434 2.50033 7.44434H12.5003C12.9725 7.44434 13.3337 7.80545 13.3337 8.27767C13.3337 8.74989 12.9725 9.111 12.5003 9.111Z",
    fill: "#FFF8EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 13.5553H2.50033C2.0281 13.5553 1.66699 13.1942 1.66699 12.722C1.66699 12.2498 2.0281 11.8887 2.50033 11.8887H17.5003C17.9725 11.8887 18.3337 12.2498 18.3337 12.722C18.3337 13.1942 17.9725 13.5553 17.5003 13.5553Z",
    fill: "#FFF8EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.0002H2.50033C2.0281 18.0002 1.66699 17.6391 1.66699 17.1668C1.66699 16.6946 2.0281 16.3335 2.50033 16.3335H12.5003C12.9725 16.3335 13.3337 16.6946 13.3337 17.1668C13.3337 17.6391 12.9725 18.0002 12.5003 18.0002Z",
    fill: "#FFF8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDevices);
export default __webpack_public_path__ + "static/media/whiteDevices.668c462b9f59520b8d9a22ad59649360.svg";
export { ForwardRef as ReactComponent };